export default {
    album: [],
    selected: [],
    package: 0,
    validatedImages: 0,
    deliveredImage: 0,
}